const state = {
  sort: 'transaction',
  date: '',
  search: '',
  logs: [],
  logsLoading: false,
  logsError: false,
  selectedLogs: [],
  currentTab: 'sticker',
  pagination: {
    skip: 0,
    take: 8,
    total: 0,
  },
  stickerTransactions: [],
  stripeTransactions: [],
  benevityTransactions: [],
  benevityW2WCreditTransactions: [],
  stickerLoading: false,
  stripeLoading: false,
  benevityLoading: false,
  benevityW2WLoading: false,
  stickerError: false,
  stripeError: false,
  benevityError: false,
  benevityW2WError: false,
};

export default state;
